export const INFLUENCER_REFERRAL_COOKIE = "iv_influencer_referral";
export const INFLUENCER_REFERRAL_ARRIVAL_EVENT = "influencer_link_arrival";
export const INFLUENCER_REFERRAL_PARAM = "influencer_referral";
export const INFLUENCER_REFERRAL_EXPIRES_AT_PARAM =
  "influencer_referral_expires_at";

export interface InfluencerReferralReceipt {
  token: string;
  handle: string;
  campaign_id: string;
  click_id: string;
  medium: string;
  expires_at: string;
}

export function influencerReferralAnalytics(
  receipt: InfluencerReferralReceipt,
) {
  return {
    campaign_id: receipt.campaign_id,
    click_id: receipt.click_id,
    medium: receipt.medium,
  };
}

export function influencerReferralArrivalAnalytics(
  receipt: InfluencerReferralReceipt,
) {
  return {
    ...influencerReferralAnalytics(receipt),
    handle: receipt.handle,
  };
}

export function parseInfluencerReferralReceipt(
  value: string | null | undefined,
  now = Date.now(),
): InfluencerReferralReceipt | null {
  if (!value) return null;

  try {
    let parsed: Record<string, unknown>;
    try {
      parsed = JSON.parse(value) as Record<string, unknown>;
    } catch {
      parsed = JSON.parse(decodeURIComponent(value)) as Record<string, unknown>;
    }
    const keys: (keyof InfluencerReferralReceipt)[] = [
      "token",
      "handle",
      "campaign_id",
      "click_id",
      "medium",
      "expires_at",
    ];
    if (keys.some((key) => typeof parsed[key] !== "string" || !parsed[key]))
      return null;

    const receipt = parsed as unknown as InfluencerReferralReceipt;
    const expiresAt = Date.parse(receipt.expires_at);
    return Number.isFinite(expiresAt) && expiresAt > now ? receipt : null;
  } catch {
    return null;
  }
}
